export { default } from './modules/TimeAgo'; // I guess these two are deprecated.

export { intlDateTimeFormatSupported, intlDateTimeFormatSupportedLocale } from './modules/locale';